export const getPriceLabel = (itemType) =>
  String(itemType || "")
    .trim()
    .toUpperCase() === "BUNDLE"
    ? "Bundled Price"
    : "Premier Price";
